import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// 🔹 Brand Images
import b1 from "../../Assets/11th_lider/2376-vc.png";
import b2 from "../../Assets/11th_lider/2377-ru.png";
import b3 from "../../Assets/11th_lider/2571-lg.png";
import b4 from "../../Assets/11th_lider/2572-rd.png";
import b5 from "../../Assets/11th_lider/2573-jv.png";
import b6 from "../../Assets/11th_lider/2656-ic.png";
import HealthStats from "./HealthStats";

const brands = [b1, b2, b3, b4, b5, b6];

const TopBrand = () => {
  const sliderRef = useRef(null);

  const scroll = (direction) => {
    const { current } = sliderRef;
    if (!current) return;

    const scrollAmount = 220;
    current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <>
        
    <section className="w-full  py-12">
      <div className="max-w-7xl mx-auto px-6">

        {/* 🔹 Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-black text-[24px] md:text-[30px] font-medium">
            Top Brand
          </h2>

          <div className="flex gap-3">
            <button
              onClick={() => scroll("left")}
              className="w-12 h-12 rounded-full bg-[#187685] flex items-center justify-center hover:opacity-90"
            >
              <ChevronLeft className="text-white" />
            </button>
            <button
              onClick={() => scroll("right")}
              className="w-12 h-12 rounded-full bg-[#187685] flex items-center justify-center hover:opacity-90"
            >
              <ChevronRight className="text-white" />
            </button>
          </div>
        </div>

        {/* 🔹 Slider */}
        <div
          ref={sliderRef}
          className="flex gap-6 overflow-x-auto scrollbar-hide scroll-smooth"
        >
          {brands.map((img, index) => (
            <div
              key={index}
              className="min-w-[185px] h-[185px] rounded-2xl overflow-hidden bg-gradient-to-br from-[#2b2b2b] to-[#111]"
            >
              <img
                src={img}
                alt="brand"
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>

      </div>
    </section>
    {/* <HealthStats/> */}
    </>
  );
};

export default TopBrand;
